import { ApiService } from '../../services/api-main'
import regStore from '../../store'

const state = {
    appBranchId: ApiService.getFormData("appBranchId"),
    linkMarketing: process.env.VUE_APP_MARKETING,
    isGuestBgLight: true,
    existingData: {
        dob        : "",
        crn        : [],
        forwardTo  : 0,
        email      : "",
        password   : "",
        hasPin     : 0,
        documentNo : "",
        showPopOver: 0,
        attempt    : 0,
        finalcrn   : [],
        mobileNo   : "",
        mobileCountryId : 0,
        newMobileNo   : "",
        newMobileCountryId : 0,
        appleToken : ""
    },
    transactionFilter: {
        startDate      : "",
        endDate        : "",
        deliveryStatus : 0 ,
        agentStatus    : 0
    },
    otp: {
        routerTo          : ""
    },
    message: {
        id              : "",
        title           : "",
        content         : "",
        subject         : "",
        date            : "",
        read            : ""
    },
    initScreenWidth     : 0,
    initScreenHeight    : 0,
    screenWidth         : 0,
    screenHeight        : 0,
    redirectToPath      : '',
    resendEVCModule: {
        timerTime       : 30,
        showTimer       : false,
        enableButton    : true,
        showButton      : true,
        attemptCount    : 0,
        time15Minutes   : '',
    },
    redirectAfterLogin: ["", 0],
    latestCountryCodePopoverDirection : "",
    isWrongReloginCustomerId : false
}

const getters = {
    appBranchId: (state) => {
        return state.appBranchId
    },
    linkMarketing: (state) => {
        return state.linkMarketing
    },
    guestBgMode: (state) => {
        return state.isGuestBgLight
    },
    initScreenWidth: (state) => {
        return state.initScreenWidth
    },
    initScreenHeight: (state) => {
        return state.initScreenHeight
    },
    screenWidth: (state) => {
        return state.screenWidth
    },
    screenHeight: (state) => {
        return state.screenHeight
    },
    redirectAfterLogin: (state) => {
        return state.redirectAfterLogin
    },
    latestCountryCodePopoverDirection: (state) => {
        return state.latestCountryCodePopoverDirection
    },
    isWrongReloginCustomerId: (state) => {
        return state.isWrongReloginCustomerId
    },
}

const actions = {
    determineAppBranchId({ commit }, isDesktop) {
        commit('determineAppBranchId', isDesktop);
    },
    setGuestBgMode({ commit }, payload) {
        commit('setGuestBgMode', payload);
    },
    setInitScreenWidth({ commit }, payload) {
        commit('setInitScreenWidth', payload);
    },
    setInitScreenHeight({ commit }, payload) {
        commit('setInitScreenHeight', payload);
    },
    setScreenWidth({ commit }, payload) {
        commit('setScreenWidth', payload);
    },
    setScreenHeight({ commit }, payload) {
        commit('setScreenHeight', payload);
    },
    setRedirectAfterLogin({ commit }, payload) {
        commit('setRedirectAfterLogin', payload);
    },
    setLatestCountryCodePopoverDirection({ commit }, payload) {
        commit('setLatestCountryCodePopoverDirection', payload);
    },
    setIsWrongReloginCustomerId({ commit }, payload) {
        commit('setIsWrongReloginCustomerId', payload)
    },
}

const mutations = {
    determineAppBranchId(state, isDesktop) {
        const isAxsr = regStore.state.registration.isAxsr;
        const axsRbId = process.env.VUE_APP_AXS_RETAIL_BRANCH_ID;
        console.log("determineAppBranchId, AXS ? "+isAxsr)

        const appBranchId = (isAxsr ? axsRbId : (isDesktop ? process.env.VUE_APP_RETAIL_BRANCH_ID_DESKTOP : process.env.VUE_APP_RETAIL_BRANCH_ID))
        console.log("determineAppBranchId rbId : "+appBranchId)
        ApiService.saveFormData("appBranchId", appBranchId)
        state.appBranchId = appBranchId
    },
    setGuestBgMode(state, payload) {
        state.isGuestBgLight = payload
    },
    setInitScreenWidth(state, payload) {
        state.initScreenWidth = payload
    },
    setInitScreenHeight(state, payload) {
        state.initScreenHeight = payload
    },
    setScreenWidth(state, payload) {
        state.screenWidth = payload
    },
    setScreenHeight(state, payload) {
        state.screenHeight = payload
    },
    setRedirectAfterLogin(state, payload) {
        state.redirectAfterLogin = payload
    },
    setLatestCountryCodePopoverDirection(state, payload) {
        state.latestCountryCodePopoverDirection = payload
    },
    setIsWrongReloginCustomerId(state, payload){
        state.isWrongReloginCustomerId = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}